<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} AI Summary
      </h3>

      <div class="section_wrap open">
        <div
          v-if="loading"
          class="widget-loading"
        >
          <i class="fa fa-btn fa-spinner fa-spin" />
          <div>Generating summary...</div>
        </div>
        <div
          v-else
          class="ai-summary_box"
          v-html="summary"
        />

        <div class="ai-summary_form">
          <label
            class="ai-summary_label"
            for="focusPoints"
          >Areas to focus on:</label>
          <div class="ai-summary_input-group">
            <input
              v-model="focusPoints"
              class="ai-summary_input"
              type="text"
              placeholder="Example, example, example..."
              :disabled="loading"
            >
            <button
              class="btn btn_md primary_btn ai-summary_btn"
              type="button"
              :disabled="loading"
              @click="generateSummary"
            >
              <svg-vue
                icon="icons/sparkles-outline"
                class="btn_icon"
              />
              <span>
                {{ !summary ? 'Generate' : 'Regenerate' }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          :disabled="!summary"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Add' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import axios from "axios";

export default {
  emits: ['refresh-widget'],
  data() {
    return {
      loading: false,
      summary: '',
      focusPoints: '',
      widget: {
        type: 'ai-summary',
        w: 12,
        h: 25,
        id: `ai-summary-${Date.now()}`,
        content: `<div id="ai-summary-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
        attributes: {
          type: "ai-summary",
          options: {
            type: 'ai-summary',
            dates: {
              toDate: null,
              fromDate: null,
              compRange: null,
              dateRange: null,
              compToDate: null,
              compFromDate: null
            },
            focusPoints: '',
            useDatesFrom: "report",
          }
        }
      },
      errors: {}
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState(['widgetModal']),
    existingWidget: function () {
      return this.widgetModal?.widget;
    },
    existingSummary: function () {
      return this.existingWidget?.content ?? '';
    },
  },
  watch: {
    focusPoints: {
      handler() {
        if (!this.focusPoints) {
          return;
        }
      }
    },
    existingWidget: {
      handler() {
        if (!this.existingWidget) {
          return;
        }
        this.widget = {...this.existingWidget};
      },
      immediate: true
    },
    existingSummary: {
      handler(existingSummary) {
        this.summary = existingSummary;
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.summary && !this.loading) {
      this.generateSummary();
    }
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    async save() {
      this.widget.attributes.options.focusPoints = this.focusPoints;
      this.widget.content = this.summary;
      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        payload.widget.resized = false;
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', payload);
      this.closeModal();
    },
    generateSummary: function () {
      this.loading = true;
      const payload = {
        focusPoints: this.focusPoints,
      };
      axios.post(`/ajax/reports/${this.report.id}/ai-summary`, payload).then(({data}) => {
        this.summary = data;
      }).finally(() => {
        this.loading = false;
      })
    },
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.section_wrap {
  padding: 2rem;
}

.widget-loading {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem 0;
}

.ai-summary_box {
  max-height: 30vh;
  overflow-y: auto;
  color: #4E4E54;
}

.ai-summary_form {
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ai-summary_input-group {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.ai-summary_label {
  font-weight: bold;
}

.ai-summary_input {
  width: 100%;
  padding: 1rem 32px;
  border-radius: 16px;
  border: 2px solid #0094FF;
  background: #FFFFFF;
}

.ai-summary_input:disabled {
  opacity: 0.5;
}

.ai-summary_btn {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn_icon {
  width: 1rem;
  height: 1rem;
}
</style>
